<template>
    <div class="bg-dim flex-col">
        <div class="modal-outside" @click="$emit('toggleBarcodePopup')" />
        <div class="safe-area absolute">
            <div class="close-wrap">
                <button class="close-box" @click="$emit('toggleBarcodePopup')" aria-label="바코드 화면 닫기"><span class="icon-close"></span></button>
            </div>
            <div class="barcode-wrap">
              <div class="barcode-flex">
<!--                <span class="icon-emarticon"></span>-->
                <img src="@/assets/images/emarticon1.png" alt="이마티콘">
                <div>
                  <span>잔액</span>
                  <strong>{{ Number(barcodeInfo.remainCash).toLocaleString() }}</strong>
                </div>
              </div>
              <div v-if="!barcodeNumber">
                <div class="barcode-box">
                  <div class="barcode-image">
                    <vue-barcode v-model="barcodeInfo.prepaidCardNo" displayValue="false" alt="바코드"
                                 height="50"
                                 width="2"
                                 elementTag="img"
                                 style="text-align: center; display: flex; flex-wrap: wrap; flex-direction: column;"
                    >
                      Show this if the rendering fails.
                    </vue-barcode>
                  </div>
                  <button class="icon-round-question barcode-button" aria-label="바코드 번호 열기" v-on:click=changeBarcodeNumber></button>
                </div>
              </div>
              <div v-else class="barcode-number-wrap">
                <span>바코드번호</span>
                <span>{{ barcodeInfo.prepaidCardNo }}</span>
                <button class="icon-small-close barcode-close-absolute" aria-label="바코드 번호 닫기" @click="changeBarcodeNumber"></button>
              </div>
            </div>
            <div v-if="barcodeInfo.showBottons" class="button-wrap">
              <button @click="goReloadPage()" :class="!barcodeInfo.reload ? 'button-disabled-square' : 'button-bg-black'" :disabled="!barcodeInfo.reload">일반충전</button>
<!--              <button @click="$router.push({name:'usageDetail', params: {prepaidCardNo:barcodeInfo.prepaidCardNo}})" class="button-bg-gray">사용내역</button>-->
              <button @click="$router.push({name:'charging', params:{cardInfo:barcodeInfo}})" :class="!barcodeInfo.autoReload? 'button-disabled-square' : 'button-bg-yellow'" :disabled="!barcodeInfo.autoReload">자동충전</button>
            </div>
        </div>
        <alert-popup v-if="showAlertPopup" @confirmPopupClickConfirm="showAlertPopup = false" :message="alertMessage"></alert-popup>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import VueBarcode from 'vue-barcode'
import AlertPopup from '../myemarticon/alertPopup.vue';

export default {
    name: 'EmarticonBarcode',
    components: {BottomButton, VueBarcode, AlertPopup },
    props: ['barcodeInfo'],
    data() {
        return  {
            barcodeNumber: false,
            showAlertPopup: false,
            alertMessage: ''
        }
    },
    methods : {
        changeBarcodeNumber() {
            this.barcodeNumber = !this.barcodeNumber;
        },
        goReloadPage() {
            //카드 상태가 사용중지가 아닐때만 충전 페이지로 이동
            if (this.barcodeInfo.status != 'LOCKED') {
                this.$router.push({ name: 'reloadCash', params: { cardInfo: this.barcodeInfo } })
            } else {
                //사용중지 상태일때 알림 팝업
                this.alertMessage = "사용중지된 카드는 충전하기를 할 수 없습니다 <br> 사용중지 해제를 먼저 해주세요"
                this.showAlertPopup = true
                return;
            }
        },
    },
    mounted() {
      // const barcode = document.querySelector('.vue-barcode-element')
      // barcode.style.width = '100%';
    }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/pages/home/emarticonBarcode.scss";
@import '@/assets/styles/common/bottomButton.scss';
</style>